import React from 'react'
import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import BillingItem from './itemsComponents/BillingItem'
import TrialItem from './itemsComponents/TrialItem'
import "./notifications.css"

const Notifications = ({ t, authUser, showModal, hideModal }) => {
  const [currentSelect, setCurrentSelect] = useState(null)

  const swtichItems = (id, itemstr) => {
    switch (itemstr) {
      case "billing":
        setCurrentSelect("billing")
        break;
      case "trial":
        setCurrentSelect("trial")
        break;
      default:
      // Do nothing
    }
    setActiveClass(id)
  }

  const setActiveClass = (id) => {
    const have = document.querySelectorAll(".nt-active-item")
    for (let i = 0; i < have.length; i++) {
      have[i].classList.remove("nt-active-item")
    }

    const childs = document.getElementById(id).childNodes
    for (let i = 0; i < childs.length; i++) {
      childs[i].classList.add("nt-active-item")
    }
  }

  const renderItemsContent = (select) => {

    if (select == "billing") {
      return <BillingItem authUser={authUser} />
    }

    if (select == "trial") {
      return <TrialItem authUser={authUser} />
    }



    return (
      <div className='nt-home'>
        Notificaciones Ruedata
      </div>
    )
  }


  const modalSelect = () => {
    const handleClose = () => {
      hideModal(false)
    }

    return (
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Body style={{ padding: '0px' }}>
          <div className="nt-container row">
            <div className='nt-side col-md-2'>
              <h2>Notificaciones</h2>
              <div className='nt-side-search'>
                <input type="text" placeholder="Search..." />
              </div>
              <div className='nt-side-items'>
                <div id='id-billing' onClick={() => swtichItems("id-billing", "billing")}>
                  <span><i class="fas fa-wallet"></i></span>
                  <p>Facturacion</p>
                </div>
                {/* <div id='id-trial' onClick={() => swtichItems("id-trial", "trial")}>
                  <span><i class="far fa-clock"></i></span>
                  <p>Tiempo Prueba</p>
                </div> */}
              </div>
            </div>
            <div className='nt-content col-md-10'>
              {renderItemsContent(currentSelect)}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
  return (
    <>
      {modalSelect()}
    </>
  )
}

export default Notifications